import { t } from "i18next";
import React, { FC } from "react";
import { CsobDataSetDataDto } from "@green0meter/api-client";
import dayjs from "dayjs";

import { Typography, Divider, Stack } from "@components/base";
import { DEFAULT_DATE_TIME_FORMAT } from "@constants";

interface DatasetHeader {
  csobDatasetComparison: CsobDataSetDataDto;
}

const DatasetHeader: FC<DatasetHeader> = ({
  csobDatasetComparison: {
    datasets,
    questionnairesCount,
    differentQuestionnairesCount,
    lastModifiedByCsob,
  },
}) => {
  // const csobDataset = datasets?.[0];
  const green0meterDataset = datasets?.[1];

  return (
    <Stack direction="row" spacing={2} alignItems="center" padding={1.5}>
      <Typography fontWeight={500}>
        {t("csob.datasetComparison.conditionBar.info.label1")} {questionnairesCount}
      </Typography>
      <Divider orientation="vertical" flexItem />
      <Typography fontWeight={500}>
        {t("csob.datasetComparison.conditionBar.info.label2")}{" "}
        {differentQuestionnairesCount}
      </Typography>
      <Divider orientation="vertical" flexItem />
      <Typography fontWeight={500}>
        {t("csob.datasetComparison.conditionBar.info.label3")}{" "}
        {lastModifiedByCsob &&
          dayjs(lastModifiedByCsob).format(DEFAULT_DATE_TIME_FORMAT)}
      </Typography>
      <Divider orientation="vertical" flexItem />
      <Typography fontWeight={500}>
        {t("csob.datasetComparison.conditionBar.info.label4")}{" "}
        {green0meterDataset?.lastEditedDateTime &&
          dayjs(green0meterDataset.lastEditedDateTime).format(
            DEFAULT_DATE_TIME_FORMAT,
          )}
      </Typography>
    </Stack>
  );
};

export default DatasetHeader;
